import {Component, Input} from '@angular/core';
import {MatDialog} from "@angular/material";
import {kanRemoveDialog} from "../../../../common/dialogs/remove-dialog/component";
import {Note} from "../../../../../classes/note";
import {kanNotesService} from "../../../../services/services/notes";
import {kanNoteDialog} from "../../../dialogs/note-dialog/component";
import {Dog} from "../../../../../classes/dog";

@Component({
    selector: 'kan-dog-notes',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
})
export class kanDogNotes {
    @Input() private dog: Dog;
    public notes: Note[];
    public filteredNotes: Note[];
    public showResolved: boolean = false;

    constructor(private dialog: MatDialog, private notesService: kanNotesService) {

    }

    ngOnInit(): void {
        this.getNotes();
    }

    public getNotes(): void {
        this.notesService.getDogNotes(this.dog.id)
            .then((notes) => {
                this.notes = notes;
                this.filter();
            })
            .catch((error) => {
                console.log(error);
            })
    }

    public openDialog(event: any) {
        let dialogRef = this.dialog.open(kanNoteDialog, {
            data: {
                user: this.dog.owner,
                dog: this.dog
            },
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed()
            .subscribe((result) => {
                if (result === 'add') {
                    this.getNotes();
                }
            });
    }

    public editNoteDialog(event, note) {
        let dialogRef = this.dialog.open(kanNoteDialog, {
            data: {
                user: this.dog.owner,
                dog: this.dog,
                note: note
            },
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed()
            .subscribe((result) => {
                if (result === 'update') {
                    this.getNotes();
                }
            });
    }

    public resolveNote(event, note) {
        note.resolved = true;
        note.end = new Date();
        this.notesService.updateNote(note)
            .then(() => {
                this.getNotes();
            });
    }

    public removeNote(event, note) {
        let dialogRef = this.dialog.open(kanRemoveDialog, {
            disableClose: true
        });

        dialogRef.afterClosed()
            .subscribe((result) => {
                if (result === 'remove') {
                    this.notesService.removeNote(note)
                        .then((data) => {
                            this.getNotes();
                        });
                }
            });
    }

    public filter() {
        this.filteredNotes = this.notes.filter((note) => {
            return !note.resolved || (this.showResolved && note.resolved)
        }).sort((note1, note2) => {
            return !note1.start ? -1 : !note2.start ? 1 : note1.start < note2.start ? 1 : note1.start > note2.start ? -1 : 0;
        });
    }

}



// WEBPACK FOOTER //
// ./src/modules/admin/components/dog/notes/component.ts